<template>
    <MainContentSearchable title="Listado de envíos" id="envíos" v-model="filters" :meta="loading ? {} : envios.meta" @updated="debouncedGetEnvios">
        <template v-slot:header>
            <div class="container-fluid px-0">
                <div class="row align-items-center flex-column flex-md-row">
                    <div class="col-12 col-md-6 mb-2 text-center text-md-left pb-1">
                        <h4 class="mb-0">Envíos</h4>
                    </div>

                    <div class="col-12 col-md-6 d-flex flex-column flex-md-row justify-content-md-end align-items-md-center pb-2">
                        <Button @click="showModal('descargar-envios')" class="w-100 w-md-auto mb-2 mr-md-2">
                            Descargar
                        </Button>
                        <Button @click="showModal('gastos-de-envio')" class="w-100 w-md-auto mb-2 mr-md-2">
                            Configurar envío
                        </Button>
                        <Button
                            target="_blank"
                            :href="url_imprimir_abonos + '&tid=' + configuracion.hash_teatro"
                            class="w-100 w-md-auto mb-2"
                            icon="fa fa-print"
                        >
                            Imprimir abonos
                        </Button>
                    </div>
                </div>
            </div>

            <EditEnvio :lista_abonados="lista_abonados" @close="closeModal" />
            <DescargarListadoEnvios
                name="descargar-envios"
                @close="closeModal"
                :searchParams="filters"
            />
        </template>
        <template v-slot:extra-options>
            <div class="col-12 col-md-6">
                <div class="input-group-sm my-3 d-flex flex-column flex-md-row" >
                    <select class="custom-select w-auto mr-2 mb-1 tw:rounded-2xl" id="search" v-model="filters.search_for" @change="debouncedGetEnvios()">
                        <option value="">Buscar por</option>
                        <option value="nombre_apellidos">Nombre y Apellidos</option>
                        <option value="domicilio">Domicilio</option>
                        <option value="cp">Código postal</option>
                        <option value="telefono">Teléfono</option>
                        <option value="fecha_pedido">Fecha del pedido</option>
                        <option value="fecha_envio">Fecha del envío</option>
                    </select>
                    <select class="custom-select w-auto mr-2 mb-1 tw:rounded-2xl" v-model="filters.estado" @change="debouncedGetEnvios()">
                        <option value="">Filtrar estado</option>
                        <option value="0">Pendiente</option>
                        <option value="1">Enviado</option>
                    </select>
                    <select class="custom-select w-auto mr-2 mb-1 tw:rounded-2xl" v-model="filters.tipo_abono" @change="debouncedGetEnvios()">
                        <option value="">Tipo de abono</option>
                        <option v-for="tipo_abonado in tipos_abonos" :value="tipo_abonado" :key="tipo_abonado.id">{{ tipo_abonado.descripcion }} <span v-if="tipo_abonado.renovacion == 1"> (renovación)</span> </option>
                    </select>
                    
                    <select class="custom-select w-auto mr-2 tw:rounded-2xl" :disabled="!filters.tipo_abono.descuentos" v-model="filters.tipo_precio" @change="debouncedGetEnvios()">
                        <option value="">Tipo de precio</option>
                        <option v-for="descuento_abonado in filters.tipo_abono.descuentos" :value="descuento_abonado" :key="descuento_abonado.id">{{ descuento_abonado.descripcion }}</option>
                    </select>
                </div>    
            </div>        
        </template>
        <template v-slot:content>
            <div v-if="envios" :class="['table', { 'expanded': envios.data?.length <= 3 }]">
                <table :class="['table', { 'expanded': envios.data?.length <= 3 }, 'table-hover text-nowrap']">
                    <thead>
                        <tr>
                            <th>NOMBRE</th>
                            <th>APELLIDOS</th>
                            <th>DOMICILIO</th>
                            <th>Localidad</th>
                            <th>Provincia</th>
                            <th>CP</th>
                            <th>TELEFONO</th>
                            <th class="text-center">OBSERVACIONES</th>
                            <th>FECHA DEL PEDIDO</th>
                            <th>FECHA DEL ENVÍO</th>
                            <th class="text-center">ESTADO</th>
                            <th class="text-center">Opciones</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <template v-for="(envio, index) in envios.data">
                            <tr :key="index">
                                <td>{{ envio.nombre }}</td>
                                <td>{{ envio.apellidos }}</td>
                                <td>{{ envio.domicilio }}</td>
                                <td>{{ envio.localidad }}</td>
                                <td>{{ envio.provincia }}</td>
                                <td>{{ envio.cp }}</td>
                                <td>{{ envio.telefono }}</td>
                                <td class="text-center">
                                    <Button v-if="envio.observaciones != null" type="button" name="tooltip" icon="fa fa-info-circle" v-b-tooltip.hover.left :title="envio.observaciones">INFO</Button>
                                </td>
                                <td>{{ envio.fecha_pedido }}</td>
                                <td>{{ envio.fecha_envio != null ? envio.fecha_envio : 'ESTE PEDIDO TODAVÍA NO SE HA ENVIADO' }}</td>
                                <td class="text-center">{{ envio.estado == 0 ? 'PENDIENTE' : 'ENVIADO' }}</td>
                                <td class="text-center">
                                    <OpcionesDropdownTableComponent 
                                        :lastIndex="envios.data?.length > 3 && index >= envios.data?.length - 3"
                                        v-bind:options="[
                                            { to: { name: 'back.envios.show', params: { envio_id: envio.id }}, label: 'Detalles'},
                                            ... envio.estado == 0 ? [{ type: 'action', action:() => sendEnvio(envio.id), label: 'Enviar'}] : [],
                                            { type: 'action', action:() => imprimirAbonos(envio.id), label: 'Imprimir abonos'}
                                        ]"
                                    />
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="6">
                                <LoaderComponent/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from "@/components/backend/components/MainContentSearchable";
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent';
    import EditEnvio from "./modals/EditEnvio.vue";
    import DescargarListadoEnvios from "./modals/DescargarListadoEnvios.vue";

    export default {
        data() {
            return {
                envios: { meta: {} },
                loading: true,
                filters: {
                    per_page:  this.$route.query.per_page ?? 10,
                    page:  this.$route.query.page ?? 1,
                    search:  this.$route.query.search ?? '',
                    search_for:  this.$route.query.search_for ?? '',
                    estado:  this.$route.query.estado ?? '',
                    tipo_abono:  this.$route.query.tipo_abono ?? "",
                    tipo_precio: this.$route.query.tipo_precio ?? ""
                },
                fields: [
                    { key: 'abonado.n_abonado', label: 'Numero abonado' },
                    { key: 'nombre', label: 'Nombre' },
                    { key: 'apellidos', label: 'Apellidos' },
                    { key: 'domicilio', label: 'Domicilio' },
                    { key: 'localidad', label: 'Localidad' },
                    { key: 'provincia', label: 'Provincia' },
                    { key: 'observaciones', label: 'Observaciones' },
                    { key: 'fecha_pedido', label: 'Fecha del pedido' },
                    { key: 'fecha_envio', label: 'Fecha del envío' },
                    { key: 'estado', label: 'Estado' },
                    { key: 'opciones', label: '', class: 'text-center' }
                ],
                tipos_abonos: null,
                envios_ids: []
            }
        },
        created() {
            this.getTipoAbono();
            this.getEnvios();
            this.debouncedGetEnvios = _.debounce(this.updateURL, 500);
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            url_imprimir_abonos() {
                const params = this.searchParams().filters;
                params.envios_ids = this.envios_ids;
                delete(params.per_page);
                delete(params.page);
                const query = new URLSearchParams(params);
                
                return this.config.API_BASE + '/envios/imprimir-busqueda?api_key=' + localStorage.getItem('token') + "&" + query;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        methods: {
            getEnvios() {
                this.loading = true;

                this.$store.dispatch(this.config.getVuexAlias('back.envios.index'), this.searchParams()).then(res => {
                    this.envios = res.data;
                    this.envios_ids = [];

                    for(var i = 0; i < this.envios.data.length; i++){
                        this.envios_ids.push(this.envios.data[i]['id']);
                    }
                }).finally(() => this.loading = false);
            },
            getTipoAbono(){
                let params = {
                    filters: {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.envios.tipo.abono'), params).then(res => {
                    this.tipos_abonos = res.data.data;
                }).finally(() => this.loading = false);
            },
            sendEnvio(id) {
                this.loading = true;

                let params = {
                    envio_id: id,
                };
                this.$store.dispatch(this.config.getVuexAlias('back.envios.enviar'), params).then(res => {
                    this.getEnvios();
                    this.$toast.success('Abono enviado correctamente.');
                }).finally(() => this.loading = false);
            },
            imprimirAbonos(id) {
                return window.open(this.config.API_BASE + '/envios/' + id + '/imprimir-abonos?api_key=' + localStorage.getItem('token') + '&tid=' + this.configuracion.hash_teatro, '_blank');
            },
            showModal(modal) {
                this.expand = [];
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            searchParams() {
                const params = {
                    filters : {
                        per_page: this.filters.per_page,
                        page: this.filters.page
                    }
                };

                if(this.filters.search !== "") {
                    params.filters.search = this.filters.search;
                }

                if(this.filters.search_for !== "") {
                    params.filters.search_for = this.filters.search_for;
                }

                if(this.filters.estado) {
                    params.filters.estado = this.filters.estado;
                }

                if(this.filters.tipo_abono && this.filters.tipo_abono.id) {
                    params.filters.tipo_abono = this.filters.tipo_abono.id;
                }

                if(this.filters.tipo_precio && this.filters.tipo_precio.id && this.filters.tipo_abono) {
                    params.filters.tipo_precio = this.filters.tipo_precio.id;
                }

                return params;
            },
            updateURL(){
                var query = {
                    per_page : this.filters.per_page,
                    page : this.filters.page,
                }
                if(this.filters.per_page != '') {
                    query.per_page = this.filters.per_page;
                }

                if(this.filters.page != '') {
                    query.page = this.filters.page;
                }

                if(this.filters.search != '') {
                    query.search = this.filters.search;
                }

                if(this.filters.search_for) {
                    query.search_for = this.filters.search_for;
                }

                if(this.filters.estado != '') {
                    query.estado = this.filters.estado;
                }

                if(this.filters.tipo_abono != '') {
                    query.tipo_abono = this.filters.tipo_abono.id;
                }

                if(this.filters.tipo_precio != '') {
                    query.tipo_precio = this.filters.tipo_precio.id;
                }

                this.$router.push({ path: '/admin/envios', query: query }).finally(() => this.getEnvios());
            },
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, EditEnvio, DescargarListadoEnvios
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>
